import registry from './config/mlbHistoricalMetrics.json';

const finiteNumber = (value) => {
  if (value === null || value === undefined || value === '' || typeof value === 'boolean') return null;
  const number = Number(value);
  return Number.isFinite(number) ? number : null;
};

export const mlbHistoricalMetricContract = (propType) =>
  registry.markets?.[String(propType || '').trim()] || null;

export function mlbHistoricalValue(row, propType) {
  const contract = mlbHistoricalMetricContract(propType);
  if (!row || !contract) return null;

  const published = finiteNumber(row[contract.json_field]);
  if (published !== null) return published;

  const fields = Array.isArray(contract.historical_source_field)
    ? contract.historical_source_field
    : [contract.historical_source_field];
  const values = fields.map((field) => finiteNumber(row[field]));
  if (values.some((value) => value === null)) return null;
  if (contract.calculation === 'SINGLES') {
    const [hits, doubles, triples, homeRuns] = values;
    return Math.max(0, hits - doubles - triples - homeRuns);
  }
  return values.length === 1 ? values[0] : values.reduce((sum, value) => sum + value, 0);
}

export function mlbHistoricalDisplayLabel(propType) {
  return mlbHistoricalMetricContract(propType)?.display_label || String(propType || 'Stat');
}

export function historicalResultStyle(value, line) {
  const actual = finiteNumber(value);
  const propLine = finiteNumber(line);
  if (actual === null || propLine === null) return { outcome: 'UNAVAILABLE', background: 'transparent' };
  if (actual > propLine) return { outcome: 'HIT', background: '#BBF7D0' };
  if (actual < propLine) return { outcome: 'MISS', background: '#FECACA' };
  return { outcome: 'EVEN', background: '#FDE68A' };
}

export function historicalRecord(rows, propType, line) {
  return (Array.isArray(rows) ? rows : []).reduce((record, row) => {
    const outcome = historicalResultStyle(mlbHistoricalValue(row, propType), line).outcome;
    if (outcome === 'HIT') record.hit += 1;
    else if (outcome === 'MISS') record.miss += 1;
    else if (outcome === 'EVEN') record.even += 1;
    else record.unavailable += 1;
    return record;
  }, { hit: 0, miss: 0, even: 0, unavailable: 0 });
}

export { registry as mlbHistoricalMetricRegistry };
